import { gql } from "@apollo/client";

export const SURVEY = gql`
query Survey($culture: String!) {
  surveyForm(where: {localization: {culture: $culture}}) {
    displayText
    fixedHeight
    columnCount
    description
    bag {
      contentItems {
        __typename
          ... on SurveyGroup {
          colspan
          displayText
          icon {
            paths
          }
          bag {
            contentItems {
              displayText
              __typename
              ... on SurveyQuestionMultiOption {
                id
                text
                multiSelect
                answerNewLine
                answerColumnCount
                bag {
                  contentItems {
                    __typename
                    ... on SurveyAnswerOption {
                      id
                      displayText
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

`